import { render } from "./FeedbackNewTicketForm.vue?vue&type=template&id=2252678c"
import script from "./FeedbackNewTicketForm.vue?vue&type=script&lang=js"
export * from "./FeedbackNewTicketForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__